const mathEntryPlugin = {
    register(globalCK) {
        if (globalCK.plugins.get('ia-mathEntry-tool')) {
            return;
        }

        globalCK.plugins.add('ia-mathEntry-tool', {
            icons: '',
            requires: 'mathjax,widget',
            init: (editorInstance) => { this.init(editorInstance); },
        });
    },

    init(editorInstance) {
        editorInstance.widgets.onWidget('mathjax', 'key', (event) => {
            if (editorInstance.readOnly) {
                event.cancel();
                event.stop();
                return false;
            }
            return undefined;
        });

        editorInstance.addCommand('openMathEntryTool', {
            exec: (editor) => {
                const { widgets } = editor;
                const selectedEl = widgets.selected && widgets.selected.length
                    ? widgets.selected[0].element : undefined;

                editor.mathEntryTriggerFunction(selectedEl);
            },
        });

        editorInstance.ui.addButton('ia-mathEntry-tool', {
            label: 'Edit formula',
            command: 'openMathEntryTool',
            toolbar: 'sketches',
        });
    },
};

export default mathEntryPlugin;
